const apiUrl = process.env.REACT_APP_API_URL;
const urlV2 = apiUrl+"/v2";
const urlV1 = apiUrl+"/v1";
const url = apiUrl+"/web/";

// const urlV2 = "https://myspon.worldvision.org.ph/api/v2";
// const urlV1 = "https://myspon.worldvision.org.ph/api/v1";
// const url = "https://myspon.worldvision.org.ph/api/web/";

// const urlDonationV2 = "https://donation-api.worldvision.org.ph/api/v2";
// const urlDonationV2 = "http://sponsorship-api.test/api/v2";

const api = {
    urlV2,
    urlV1,
    url
}

export default api;